<template>
    <v-alert
        v-if="showAlert"
        :type="alertType"
        class="mx-auto text-center"
        style="position: fixed; top: 20px; left: 0; right: 0; z-index: 9999; max-width: 600px;"
        elevation="2"
        prominent
    >
        {{ alertMessage }}
    </v-alert>
    <v-container fluid>
        <v-card class="pa-4" elevation="2">
            <v-row>
                <v-col class="headline mb-4">
                    <h2>Salidas de almacen</h2>
                </v-col>
                <v-col cols="12" sm="6" style="text-align: right">
                    <v-btn color="primary" :loading="isImporting" :disabled="isImporting" @click="startDepartures" v-if="!isWarehouse">
                        <template #loader>
                            <v-progress-circular indeterminate size="20" color="white" />
                        </template>
                        Generar salidas
                    </v-btn>
                    <v-btn style="margin-left: 10px"  @click="$router.back()">Volver</v-btn>
                </v-col>
            </v-row>

            <v-row class="mb-4" dense>
                <v-col cols="12" sm="4">
                    <v-text-field v-model="filters.provider" label="Filtrar por Proveedor" dense clearable />
                </v-col>
            </v-row>

            <v-data-table
                :items="filteredDepartures"
                :headers="headers"
                class="elevation-1"
                item-value="id"
                no-data-text="No hay lineas de salidas disponibles"
            >
                <template #item.actions="{ item }">
                    <v-btn
                        icon
                        class="ma-1"
                        title="Validar"
                        @click="onValidate(item)"
                        :disabled="item.status === 'delivered'"
                    >
                        <v-icon>mdi-check</v-icon>
                    </v-btn>
                    <v-btn  icon class="ma-1" title="Historial" @click="onHistory(item)">
                        <v-icon>mdi-history</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script setup>
import { ref, onMounted, inject, computed } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

const isWarehouse = inject('isWarehouse')

const router = useRouter()

const isImporting = ref(false)

import { useAlert } from '@/composables/useAlert'

const {
    alertMessage,
    alertType,
    showAlert,
    showAlertMessage
} = useAlert()

const departures = ref([])

const headers = [
    { title: 'Proveedor', value: 'provider', sortable: true },
    { title: 'Cantidad', value: 'quantity', sortable: true },
    { title: 'Estado', value: 'status', sortable: true },
    { title: 'Acciones', value: 'actions', sortable: false }
]

// Filtres
const filters = ref({
    provider: '',
})

const filteredDepartures = computed(() => {
    return departures.value.filter((departure) => {
        return (
            (!filters.value.provider || lower(departure?.provider).includes(lower(filters.value.provider)))
        )
    })
})

const lower = (v) => (v ?? '').toString().toLowerCase()
const normalizeActive = (val) => {
    if (typeof val === 'boolean') return val
    if (typeof val === 'number') return val === 1
    if (typeof val === 'string') return val === '1' || val.toLowerCase() === 'true'
    return false
}

const fetchDepartures = async () => {
    try {

        const { data } = await axios.get(`/api/admin/departures/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })

        console.log(data)

        departures.value = data

    } catch (e) {
        console.error('Error al cargar líneas de salidas:', e)
        if (e.response?.status === 401) {
            localStorage.removeItem('token')
            await router.push('/')
        }
    }
}

const startDepartures = async () => {
    isImporting.value = true
    showAlertMessage('Generando salidas...', 'success')
    try {
        await axios.post('/api/admin/departures/import', {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        await fetchDepartures()
        showAlertMessage('Salidas generadas correctamente.', 'success')
    } catch (e) {
        console.error('Error al importar salidas:', e)
        showAlertMessage('Error al importar salidas', 'error')
    } finally {
        isImporting.value = false
    }
}

const onValidate = async (item) => {
    try {
        await axios.post(`/api/admin/departures/${item.providerId}/validate`, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })

        await fetchDepartures()
    } catch (error) {
        if (error.response?.data?.message) {
            showAlertMessage(error.response.data.message, 'error')
        } else {
            showAlertMessage('Error inesperado al validar la salida', 'error')
        }
    }
}

const onHistory = (item) => {
    router.push(`departures/history/${item.providerId}`)
}

onMounted(fetchDepartures)
</script>
